import moment from 'moment'
import { Network } from '../../../utils/network'
import { Formatter } from '../formatter'

import urls from './urls.json'

async function getMatches(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, data)
  return parsedResponse
}

async function sendRequest(data) {
  const timestamp = data.date
  const now = moment(new Date().setHours(0, 0, 0, 0))
  const date = moment(new Date(timestamp).setHours(0, 0, 0, 0))
  const diffInDays = date.diff(now, 'days')
  if (!date.isSame(now, 'day') && data.getLive) {
    return {
      status: { code: 200 },
      response: { data: { matches: [] } },
    }
  }

  let url = `${urls.upcomingMatches}${diffInDays}`
  if (data.getLive) url = urls.liveMatches

  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response, data) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawData = response.response?.data?.matches
    const parsed = data.getLive
      ? Formatter.parseLiveMatches(rawData)
      : Formatter.parseUpcomingMatches(rawData)

    return {
      success: true,
      data: parsed,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { getMatches }
